"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageLayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_maps_1 = require("@yanzi/react-maps");
const react_ui_1 = require("@yanzi/react-ui");
const react_1 = require("react");
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
function ImageLayer(_a) {
    var _b, _c, _d;
    var { baseUrl, layer, opacity } = _a, props = __rest(_a, ["baseUrl", "layer", "opacity"]);
    const path = `${baseUrl}/${layer.src}`;
    const { data, loading } = react_cirrus_store_1.useCirrusStoreGet(path, 'raw');
    const [image, setImage] = react_1.useState(null);
    const [dimensions, setDimensions] = react_1.useState(null);
    react_1.useEffect(() => {
        if (!data) {
            return;
        }
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a, _b;
            const result = (_b = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result) !== null && _b !== void 0 ? _b : null;
            if (typeof result === 'string' && !!result) {
                setImage(result);
            }
            else {
                console.error('Strange type of image.');
            }
        };
        reader.readAsDataURL(new Blob([data]));
    }, [data, setImage]);
    react_1.useEffect(() => {
        if (!image) {
            return;
        }
        var img = new Image();
        img.onload = function () {
            setDimensions([img.width, img.height]);
        };
        img.src = image;
    }, [image]);
    const bounds = (_b = layer === null || layer === void 0 ? void 0 : layer.bounds) !== null && _b !== void 0 ? _b : null;
    const brBounds = (_c = bounds === null || bounds === void 0 ? void 0 : bounds.bottomRight) !== null && _c !== void 0 ? _c : null;
    const tlBounds = (_d = bounds === null || bounds === void 0 ? void 0 : bounds.topLeft) !== null && _d !== void 0 ? _d : null;
    const bottomRight = react_1.useMemo(() => {
        var _a, _b;
        const lat = (_a = brBounds === null || brBounds === void 0 ? void 0 : brBounds.latitude) !== null && _a !== void 0 ? _a : null;
        const long = (_b = brBounds === null || brBounds === void 0 ? void 0 : brBounds.longitude) !== null && _b !== void 0 ? _b : null;
        if (lat !== null && long !== null) {
            return [long, lat];
        }
        return null;
    }, [brBounds]);
    const topLeft = react_1.useMemo(() => {
        var _a, _b;
        const lat = (_a = tlBounds === null || tlBounds === void 0 ? void 0 : tlBounds.latitude) !== null && _a !== void 0 ? _a : null;
        const long = (_b = tlBounds === null || tlBounds === void 0 ? void 0 : tlBounds.longitude) !== null && _b !== void 0 ? _b : null;
        if (lat !== null && long !== null) {
            return [long, lat];
        }
        return null;
    }, [tlBounds]);
    if (loading) {
        return jsx_runtime_1.jsx(react_ui_1.BarLoader, {}, void 0);
    }
    if (!topLeft || !bottomRight || !dimensions || !image) {
        return null;
    }
    return (jsx_runtime_1.jsx(react_maps_1.ImageLayer, Object.assign({ src: image, dimensions: dimensions, bottomRight: bottomRight, topLeft: topLeft, draggable: false, opacity: layer.opacity !== undefined
            ? layer.opacity * (opacity !== undefined ? opacity : 1)
            : opacity }, props), void 0));
}
exports.ImageLayer = ImageLayer;
//# sourceMappingURL=Image.js.map